import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  paper: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 0, // Sharp edges - no rounding
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flex: 1,
    p: 2,
    position: 'relative',
    boxShadow: 1,
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: 4,
      transform: 'translateY(-1px)',
    },
  },
  editButton: {
    position: 'absolute', // Position the button absolutely within the paper
    width: 'auto',
    height: 'auto',
    top: 8, // Adjust this value to control vertical offset
    right: 8, // Adjust this value to control horizontal offset
  },
};

export default styles;
